import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { PARTNER_CONSENT } from 'constants/controllers'
import Main from './Main'

export default new Controller({
  name: PARTNER_CONSENT,
  route: 'partner-consent',
  controller (Router, { query: { consent_challenge: consentChallenge = '' } }, render) {
    const pageId = getUrl(PARTNER_CONSENT)
    render(
      { Main },
      { consentChallenge },
      { pageId, className: 'partner-consent' }
    )
    return pageId
  }
})
